/* ==========================================================================
   Soybarber — sb-fx.js
   Segunda tanda de primitivas de motion-primitives, portadas a WAAPI/rAF.
   Se carga despues de sb-motion.js y no depende de el.

     data-scan            escaner: la maquina gira angulo por angulo al bajar
     data-slide-bg        AnimatedBackground: una pastilla que viaja al activo
     data-scramble        TextScramble: el texto se descifra al entrar
     data-progress        ScrollProgress: barra de avance de lectura
     data-mag             Magnetic con radio global + anidado
     (todos los .sb-btn)  prensa con resorte al tocar

   Reglas: solo transform/opacity, un rAF compartido, nada corre fuera de
   pantalla, y con prefers-reduced-motion no se activa ninguna.
   ========================================================================== */
(function () {
  'use strict';
  var doc = document;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function $$(s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); }

  /* --- rAF compartido: un solo bucle para todo lo que depende del scroll -- */
  var tareas = [], pendiente = false;
  function tick() {
    if (pendiente) return;
    pendiente = true;
    requestAnimationFrame(function () {
      pendiente = false;
      for (var i = 0; i < tareas.length; i++) tareas[i]();
    });
  }
  window.addEventListener('scroll', tick, { passive: true });
  window.addEventListener('resize', tick);

  /* --- 1. Escaner ------------------------------------------------------ */
  function initScan() {
    $$('[data-scan]:not([data-scan-ready])').forEach(function (sec) {
      sec.setAttribute('data-scan-ready', '');
      var rail = sec.querySelector('.sb-scan__rail');
      var frames = $$('[data-scan-frame]', sec);
      var specs = $$('[data-scan-spec]', sec);
      var bar = sec.querySelector('[data-scan-bar]');
      if (!rail || frames.length < 2) return;

      var n = frames.length, actual = -1, visible = false;

      function pinta() {
        if (!visible) return;
        var b = rail.getBoundingClientRect();
        var recorrido = b.height - window.innerHeight;
        if (recorrido <= 0) return;
        var p = Math.max(0, Math.min(1, -b.top / recorrido));
        /* Se reparte el recorrido entre los fotogramas, con un pelo de margen
           al final para que el ultimo alcance a leerse. */
        var idx = Math.min(n - 1, Math.floor(p * n * 0.999));
        if (bar) bar.style.width = (p * 100).toFixed(1) + '%';
        if (idx === actual) return;
        actual = idx;
        frames.forEach(function (f, i) {
          f.classList.toggle('is-on', i === idx);
          f.classList.toggle('is-past', i < idx);
        });
        specs.forEach(function (s, i) { s.classList.toggle('is-on', i === idx); });
      }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          visible = es[0].isIntersecting;
          if (visible) pinta();
        }, { threshold: 0 }).observe(sec);
      } else { visible = true; }
      tareas.push(pinta);
      pinta();
    });
  }

  /* --- 2. AnimatedBackground ------------------------------------------- */
  function initSlideBg() {
    $$('[data-slide-bg]:not([data-slide-ready])').forEach(function (grupo) {
      grupo.setAttribute('data-slide-ready', '');
      grupo.classList.add('sb-ab');
      var pill = doc.createElement('span');
      pill.className = 'sb-ab__pill';
      pill.setAttribute('aria-hidden', 'true');
      grupo.insertBefore(pill, grupo.firstChild);
      var items = $$('[data-slide-item]', grupo);
      if (!items.length) return;

      function mover(el) {
        if (!el) { pill.style.opacity = '0'; return; }
        var g = grupo.getBoundingClientRect(), r = el.getBoundingClientRect();
        pill.style.width = r.width + 'px';
        pill.style.height = r.height + 'px';
        pill.style.transform = 'translate(' + (r.left - g.left) + 'px,' + (r.top - g.top) + 'px)';
        pill.style.opacity = '1';
      }
      items.forEach(function (el) {
        el.addEventListener('mouseenter', function () { mover(el); });
        el.addEventListener('focusin', function () { mover(el); });
      });
      grupo.addEventListener('mouseleave', function () { mover(null); });
      grupo.addEventListener('focusout', function (e) {
        if (!grupo.contains(e.relatedTarget)) mover(null);
      });
    });
  }

  /* --- 3. TextScramble -------------------------------------------------- */
  var GLIFOS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789/\\|<>*#';
  function initScramble() {
    $$('[data-scramble]:not([data-scramble-ready])').forEach(function (el) {
      el.setAttribute('data-scramble-ready', '');
      var real = el.textContent;
      var dur = parseInt(el.getAttribute('data-scramble') || '700', 10);
      el.style.minWidth = el.getBoundingClientRect().width + 'px';
      function correr() {
        var t0 = null;
        function paso(t) {
          if (!t0) t0 = t;
          var p = Math.min((t - t0) / dur, 1);
          var fijos = Math.floor(real.length * p);
          var out = '';
          for (var i = 0; i < real.length; i++) {
            if (i < fijos || real[i] === ' ') out += real[i];
            else out += GLIFOS[(Math.random() * GLIFOS.length) | 0];
          }
          el.textContent = out;
          if (p < 1) requestAnimationFrame(paso); else el.textContent = real;
        }
        requestAnimationFrame(paso);
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          if (es[0].isIntersecting) { io.disconnect(); correr(); }
        }, { threshold: 0.5 });
        io.observe(el);
      } else { correr(); }
    });
  }

  /* --- 4. ScrollProgress ------------------------------------------------ */
  function initProgress() {
    var host = doc.querySelector('[data-progress]');
    if (!host || host.hasAttribute('data-progress-ready')) return;
    host.setAttribute('data-progress-ready', '');
    var bar = host.querySelector('span');
    if (!bar) return;
    function pinta() {
      var h = doc.documentElement.scrollHeight - window.innerHeight;
      bar.style.width = h > 0 ? Math.min(100, (window.scrollY / h) * 100).toFixed(2) + '%' : '0%';
    }
    tareas.push(pinta);
    pinta();
  }

  /* --- 5. Prensa de boton ---------------------------------------------- */
  function initPress() {
    doc.addEventListener('pointerdown', function (e) {
      var b = e.target.closest && e.target.closest('.sb-btn');
      if (b) b.classList.add('is-pressed');
    }, { passive: true });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
      doc.addEventListener(ev, function () {
        $$('.sb-btn.is-pressed').forEach(function (b) { b.classList.remove('is-pressed'); });
      }, { passive: true });
    });
  }

  /* --- 6. Magnetic anidado (actionArea global) --------------------------
     La version buena de magnetic.tsx: el boton no espera a que le pases el
     cursor encima, reacciona cuando te ACERCAS. Se mide la distancia del
     puntero al centro y dentro del radio se inclina hacia el, con caida suave
     al borde del radio.

     Anidado: el texto de adentro lleva su propia intensidad, mas baja. Como se
     mueve menos que el boton, se genera profundidad; es lo que hace que no
     parezca un bloque desplazandose.

     Solo con puntero fino. En tactil no aporta y ademas el 96.6% del trafico es
     movil, asi que ni se registra el listener. */
  function initMagnetic() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var nodos = $$('[data-mag]:not([data-mag-ready])');
    if (!nodos.length) return;

    var regs = [];
    nodos.forEach(function (el) {
      el.setAttribute('data-mag-ready', '');
      var inner = el.querySelector('[data-mag-inner]');
      regs.push({
        el: el,
        inner: inner,
        fuerza: parseFloat(el.getAttribute('data-mag') || '0.2'),
        fuerzaIn: inner ? parseFloat(inner.getAttribute('data-mag-inner') || '0.1') : 0,
        radio: parseFloat(el.getAttribute('data-mag-range') || '200'),
        activo: false
      });
    });

    var mx = -9999, my = -9999, pedido = false;
    function pinta() {
      pedido = false;
      for (var i = 0; i < regs.length; i++) {
        var r = regs[i];
        var b = r.el.getBoundingClientRect();
        if (!b.width) continue;
        var cx = b.left + b.width / 2, cy = b.top + b.height / 2;
        var dx = mx - cx, dy = my - cy;
        var dist = Math.sqrt(dx * dx + dy * dy);
        if (dist > r.radio) {
          if (r.activo) {
            r.el.style.transform = '';
            if (r.inner) r.inner.style.transform = '';
            r.activo = false;
          }
          continue;
        }
        r.activo = true;
        /* Caida suave: pega mas cuando el cursor esta cerca del centro. */
        var caida = 1 - dist / r.radio;
        var f = r.fuerza * caida;
        r.el.style.transform = 'translate(' + (dx * f).toFixed(1) + 'px,' + (dy * f).toFixed(1) + 'px)';
        if (r.inner) {
          var fi = r.fuerzaIn * caida;
          r.inner.style.transform = 'translate(' + (dx * fi).toFixed(1) + 'px,' + (dy * fi).toFixed(1) + 'px)';
        }
      }
    }
    window.addEventListener('pointermove', function (e) {
      mx = e.clientX; my = e.clientY;
      if (!pedido) { pedido = true; requestAnimationFrame(pinta); }
    }, { passive: true });
    window.addEventListener('pointerleave', function () {
      mx = -9999; my = -9999;
      if (!pedido) { pedido = true; requestAnimationFrame(pinta); }
    }, { passive: true });
    tareas.push(function () { if (mx > -9999) pinta(); });
  }

  function init() {
    initScan();
    initSlideBg();
    initScramble();
    initProgress();
    initMagnetic();
  }
  initPress();
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
  doc.addEventListener('shopify:section:load', init);
})();
